import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Avatar, Box, Grid, Stack, Tab, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { allMatriculasAction } from '../../../control_estudios/matriculas/MatriculasAction';
import SelectFieldSeccionesComponent from '../../../control_estudios/secciones/components/SelectFieldSecciones';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { SECCION_RECIBOS } from '../RecibosReducer';

const TablaMatriculasRecibosComponent = ({
  selectsMatriculas,
  onClick,
  onAll,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const matriculasStore = Redux.useSelector((state) => state.matriculas);
  const recibosStore = Redux.useSelector((state) => state.recibos);

  const [tab, setTab] = React.useState('1');
  const handleTabs = (event, newValue) => {
    setTab(newValue);
  };

  React.useEffect(() => {
    async function fetchData() {
      if (recibosStore.idSeccion) {
        await allMatriculasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
          idSeccion: recibosStore.idSeccion,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recibosStore.idSeccion]);

  function getLista(select, data = []) {
    return (
      <Grid item md={12}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>Representantes</TableCell>
                {select && <TableCell>Sección</TableCell>}
                <TableCell align="left">
                  Acción
                  {(!select || selectsMatriculas.length > 0) && (
                    <BotonComponent
                      variant="contained"
                      blue
                      click={() => {
                        onAll(select);
                        setTab(!select ? '1' : '2');
                      }}
                      text="TODOS"
                      ml={1}
                    />
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((el, index) => {
                let exist = false;
                if (!select) {
                  exist = selectsMatriculas.some((e) => e.id === el.id);
                }

                const titular = el.estudiante.usuario.familiares.find(
                  (e) => e.titular,
                );
                const seccion = el.secciones.find((e) => !e.aprobado);

                return (
                  !exist &&
                  titular && (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Stack direction="row" spacing={1} alignItems="center">
                          {/* {exist ? <CheckIcon fontSize="small" /> : null} */}
                          <Avatar
                            alt={el.estudiante.usuario.perfil.pnombre}
                            sx={{ width: 30, height: 30 }}
                            src={getFilesArchivos(
                              el.estudiante.usuario.perfil.avatar,
                            )}
                          />
                          <Stack alignItems="flex-start">
                            {titular && (
                              <Typography
                                sx={{
                                  fontWeight: 'bold',
                                  color: 'black',
                                  mr: 2,
                                }}
                              >
                                {titular.familiar.perfil.tipoDni}
                                {'-'}
                                {titular.familiar.perfil.dni}{' '}
                                {titular.familiar.perfil.pnombre}{' '}
                                {titular.familiar.perfil.papellido}
                              </Typography>
                            )}
                            <Typography
                              sx={{
                                fontWeight: 'normal',
                                color: 'black',
                                fontSize: '10pt',
                              }}
                            >
                              {el.estudiante.usuario.perfil.tipoDni}
                              {'-'}
                              {el.estudiante.usuario.perfil.dni}{' '}
                              {el.estudiante.usuario.perfil.pnombre}{' '}
                              {el.estudiante.usuario.perfil.papellido}
                            </Typography>
                          </Stack>
                        </Stack>
                      </TableCell>
                      {select && (
                        <TableCell>
                          <Typography variant="subTitle1" color="initial">
                            <strong>Nivel: </strong>{' '}
                            {
                              seccion.seccion.nivelAcademico.nivelAcademico
                                .nombre
                            }
                          </Typography>
                          <br />
                          <Typography variant="subTitle1" color="initial">
                            <strong>Sección:</strong> {seccion.seccion.nombre}
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell align="left">
                        <BotonComponent
                          click={() => onClick(el)}
                          green={!select}
                          red={select}
                          checkIcon={!select}
                          closeIcon={select}
                          text={select ? 'Eliminar' : 'Seleccionar'}
                        />
                      </TableCell>
                    </TableRow>
                  )
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    );
  }

  const lista = (
    <Grid container spacing={1}>
      <Grid item md={12} sx={{ pt: 2 }}>
        <SelectFieldSeccionesComponent
          value={recibosStore.idSeccion}
          isAll={false}
          isEmpty={false}
          onChange={(idSeccion) => {
            dispatch({
              type: SECCION_RECIBOS,
              payload: idSeccion,
            });
          }}
        />
      </Grid>
      <Grid item md={12}>
        <LoadingWidget isLoading={matriculasStore.loadingAll} />
        {getLista(false, matriculasStore.all)}
      </Grid>
    </Grid>
  );

  return (
    <TabContext value={tab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleTabs} aria-label="lab API tabs example">
          <Tab
            label={`Seleccionados (${selectsMatriculas.length})`}
            value="1"
          />
          <Tab label="Representantes" value="2" />
        </TabList>
      </Box>
      <TabPanel value="1" sx={{ p: 0 }}>
        {getLista(true, selectsMatriculas)}
      </TabPanel>
      <TabPanel value="2" sx={{ p: 0 }}>
        {lista}
      </TabPanel>
    </TabContext>
  );
};

export default TablaMatriculasRecibosComponent;
